import { useEffect, useState } from "react";
import { useNotifyContext } from "../../../components/Notify";
import req from "../../../../modules/Request";
import { useNavigator } from "../../../components/Navigator";
import { LoadingProvider } from "../../../components/LoadingScreen";


const useDevices = () => {
  const [ loadingDevices, setLoadingDevices ] = useState(false);
  const [ devices, setDevices ] = useState([]);
  const { notify } = useNotifyContext();
  
  const fetchDevices = async () => {
    setLoadingDevices(true);

    const res = await req('select-devices');

    if(res.success) {
      setDevices(res.data);
    } else {
      notify("Error", "Please contact the administrator", 'error');
    }

    setLoadingDevices(false);
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  return { devices, setDevices, fetchDevices, loadingDevices };
};

export default useDevices;